import React, { FC, useState } from "react"

export const SpecialRecoverMessage: FC = () => <div>Log in to <a href={"https://kevinmurphyinsider.com"} className={'error-link'} > kevinmurphyinsider.com </a> to recover your password </div>
